import { createRoot } from 'react-dom/client';
import './styles/tailwind.css';
import App from './components/App.js';

var mountNode = document.getElementById('shelter-library-viewer');
let root = createRoot(mountNode);
root.render(<App />);
